import type { ReactNode } from 'react';
import { WagmiProvider, createConfig, http } from 'wagmi';
import { mainnet, arbitrum } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { injected } from 'wagmi/connectors';

// Configure chains and connectors
const config = createConfig({
  chains: [arbitrum, mainnet],
  connectors: [
    injected(),
    // walletConnect({ projectId: 'YOUR_PROJECT_ID' }), // Uncomment when you have a WalletConnect project ID
  ],
  transports: {
    [arbitrum.id]: http(),
    [mainnet.id]: http(),
  },
});

const queryClient = new QueryClient();

interface WalletProviderProps {
  children: ReactNode;
}

export function WalletProvider({ children }: WalletProviderProps) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}
